import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useRef, useState, useEffect } from 'react';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import DEFAULT_OPERATIONS from './resources.gql';
import mergeOperations from '@magento/peregrine/lib/util/shallowMerge';
import META_OPERATIONS from 'src/pages/Collections/collections.gql';
/**
 *
 * @param {*} props.operations GraphQL operations used by talons
 */

export var useResources = function useResources() {
  var _categoryData$categor, _categoryData$categor2;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _mergeOperations = mergeOperations(DEFAULT_OPERATIONS, props.operations),
      requestResources = _mergeOperations.requestResources,
      getResourcesAll = _mergeOperations.getResourcesAll,
      getProductResources = _mergeOperations.getProductResources,
      downloadFiles = _mergeOperations.downloadFiles,
      getResourcesImages = _mergeOperations.getResourcesImages,
      getPimcoreAssetHost = _mergeOperations.getPimcoreAssetHost;
  /*  const [searchingResources, setSearchingResources] = useState(false);*/


  var formApiRef = useRef(null);
  var setFormApi = useCallback(function (api) {
    return formApiRef.current = api;
  }, []);

  var _useLazyQuery = useLazyQuery(downloadFiles, {
    fetchPolicy: 'no-cache'
  }),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      downloadFilesLazyQuery = _useLazyQuery2[0],
      data = _useLazyQuery2[1].data;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      isSearchEmpty = _useState2[0],
      setIsSearchEmpty = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      requestingResources = _useState4[0],
      setRequestingResources = _useState4[1];

  var _useQuery = useQuery(getResourcesAll, {
    fetchPolicy: 'network-only'
  }),
      resourcesAll = _useQuery.data,
      errorAll = _useQuery.error,
      loadingAll = _useQuery.loading,
      refetch = _useQuery.refetch;

  var _useQuery2 = useQuery(META_OPERATIONS.getCmsPageMeta, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
    variables: {
      filters: {
        url_key: {
          eq: 'professional-resources'
        }
      }
    }
  }),
      categoryLoading = _useQuery2.loading,
      categoryError = _useQuery2.error,
      categoryData = _useQuery2.data;

  var _useQuery3 = useQuery(getPimcoreAssetHost, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  }),
      storeConfigData = _useQuery3.data;

  useEffect(function () {
    return data && window.open(data === null || data === void 0 ? void 0 : data.downloadFiles, '_blank');
  }, [data]);

  var handleDownload = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(files) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", downloadFilesLazyQuery({
                variables: {
                  input: {
                    file_type: 'files',
                    files: files
                  }
                }
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleDownload(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var _useLazyQuery3 = useLazyQuery(getProductResources, {
    fetchPolicy: 'cache-and-network'
  }),
      _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
      getProductResourcesQuery = _useLazyQuery4[0],
      _useLazyQuery4$ = _useLazyQuery4[1],
      loadingProduct = _useLazyQuery4$.loadingProduct,
      errorProduct = _useLazyQuery4$.errorProduct,
      productResources = _useLazyQuery4$.data;

  var _useLazyQuery5 = useLazyQuery(getResourcesImages, {
    fetchPolicy: 'no-cache'
  }),
      _useLazyQuery6 = _slicedToArray(_useLazyQuery5, 2),
      getImagesAssets = _useLazyQuery6[0],
      _useLazyQuery6$ = _useLazyQuery6[1],
      loadingImages = _useLazyQuery6$.loading,
      errorImages = _useLazyQuery6$.error,
      imagesData = _useLazyQuery6$.data;

  var _useMutation = useMutation(requestResources, {
    fetchPolicy: 'no-cache'
  }),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      requestResourcesMutation = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      requestResourcesError = _useMutation2$.error,
      requestResourcesResponse = _useMutation2$.data;

  var handleSearch = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(searchData) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsSearchEmpty(searchData);
              _context2.next = 3;
              return getProductResourcesQuery({
                variables: {
                  sku: searchData
                }
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var handleSubmitRequestResources = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(requestData) {
      var _requestData$role, _requestData$fileType;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setRequestingResources(true);
              _context3.prev = 1;
              _context3.next = 4;
              return requestResourcesMutation({
                variables: {
                  company: requestData.company,
                  first_name: requestData.firstName,
                  last_name: requestData.lastName,
                  project_name: requestData.projectName,
                  message: requestData.message,
                  role: ((_requestData$role = requestData.role) === null || _requestData$role === void 0 ? void 0 : _requestData$role.value) || '',
                  email: requestData.email,
                  zip: requestData.zip,
                  file_type: ((_requestData$fileType = requestData.fileType) === null || _requestData$fileType === void 0 ? void 0 : _requestData$fileType.value) || '',
                  base_item: requestData.baseItem,
                  consent_collect_data: requestData.consentCollectData ? 'true' : 'false'
                }
              });

            case 4:
              if (formApiRef.current) formApiRef.current.reset();
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);
              if (process.env.NODE_ENV !== 'production') console.error(_context3.t0);

            case 10:
              setRequestingResources(false);

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 7]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  var handleSearchImage = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(sku) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return getImagesAssets({
                variables: {
                  sku: sku
                }
              });

            case 3:
              _context4.next = 8;
              break;

            case 5:
              _context4.prev = 5;
              _context4.t0 = _context4["catch"](0);

              if (process.env.NODE_ENV !== 'production') {
                console.error(_context4.t0);
              }

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 5]]);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }(), []);
  var category = categoryData === null || categoryData === void 0 ? void 0 : (_categoryData$categor = categoryData.categories) === null || _categoryData$categor === void 0 ? void 0 : (_categoryData$categor2 = _categoryData$categor.items) === null || _categoryData$categor2 === void 0 ? void 0 : _categoryData$categor2[0];
  var pimcoreAssetHost = 'https://d1dzdvn5l1godq.cloudfront.net/assets';
  return {
    setFormApi: setFormApi,
    loadingAll: loadingAll,
    loadingProduct: loadingProduct,
    errorAll: errorAll,
    errorProduct: errorProduct,
    handleSearch: handleSearch,
    handleSubmitRequestResources: handleSubmitRequestResources,
    isBusyRequesting: requestingResources,
    requestResourcesError: requestResourcesError,
    requestResourcesResponse: requestResourcesResponse,
    productResources: productResources === null || productResources === void 0 ? void 0 : productResources.products,
    resourcesAll: resourcesAll === null || resourcesAll === void 0 ? void 0 : resourcesAll.resourcesAll,
    refetch: refetch,
    handleDownload: handleDownload,
    handleSearchImage: handleSearchImage,
    imagesData: imagesData === null || imagesData === void 0 ? void 0 : imagesData.products,
    formApiRef: formApiRef,
    isSearchEmpty: isSearchEmpty,
    loadingImages: loadingImages,
    category: category,
    pimcoreAssetHost: storeConfigData && storeConfigData.storeConfig && storeConfigData.storeConfig.pimcore_assets_host
  };
};